import { REHYDRATE } from 'redux-persist';
import * as types from 'actions/types';
import { LOGGED_OUT } from 'actions/types';
const initialState = {
    setUpState: {},
    monthlyCategories: undefined,
    monthlyMerchants: undefined,
    monthlyTotal: undefined,
    showEmmaSteps: false, // this is to show emma steps after walkthrough
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            const { setUpEmma } = action.payload || {};
            return {
                ...state,
                ...setUpEmma,
                monthlyCategories: undefined,
                monthlyMerchants: undefined,
                monthlyTotal: undefined,
            };
        }
        case 'SET_SHOW_SETUP_EMMA_STEPS':
            return { ...state, showEmmaSteps: action.value };
        case 'UPDATE_SETUP_EMMA_STEP': {
            return {
                ...state,
                setUpState: {
                    ...state.setUpState,
                    [action.stepId]: action.isCompleted,
                },
            };
        }
        case types.MONTHLY_CATEGORIES_SUCCESS: {
            if (action.extra.flow !== 'setUpEmma' || action.extra.withPreviousPlan) {
                return state;
            }
            const { total, ...rest } = action.payload;
            return {
                ...state,
                monthlyCategories: rest,
                monthlyTotal: { amount: total, currency: rest.currency },
            };
        }
        case types.MONTHLY_MERCHANTS_SUCCESS: {
            if (action.extra.flow !== 'setUpEmma')
                return state;
            const { total, currency, ...rest } = action.payload;
            return {
                ...state,
                monthlyMerchants: rest,
                monthlyTotal: { amount: total, currency },
            };
        }
        case LOGGED_OUT:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
